import { Component, OnInit } from '@angular/core';
import { combineLatest, map } from 'rxjs';
import { EtlMonitorService } from '../../services/etl-monitor.service';

interface FileProcessingData {
  fileName: string;
  uploadTime: string;
  status: 'Processing' | 'Queued' | 'Completed' | 'Failed';
  progress: number;
  processingRecords: string;
  categories: { name: string; status: 'complete' | 'pending' | 'error' }[];
}

interface OverallProgress {
  fileName: string;
  totalRecords: number;
  processedRecords: number;
  percentComplete: number;
  totalFiles: number;
  completedFiles: number;
  queuedFiles: number;
  failedRecords: number;
}

@Component({
  selector: 'app-etl-monitor',
  templateUrl: './etl-monitor.component.html',
  styleUrls: ['./etl-monitor.component.scss'],
})
export class EtlMonitorComponent implements OnInit {
  viewModel$ = combineLatest([
    this.etlMonitorService.getEtlFileStatus(),
    this.etlMonitorService.GetETLInQueueFileStatus(),
  ]).pipe(
    map(([processedFiles, inQueueFiles]) => {
      return { processedFiles, inQueueFiles };
    })
  );
  viewMode: 'grid' | 'list' = 'grid';

  constructor(private etlMonitorService: EtlMonitorService) {}

  ngOnInit(): void {
    // Initialize component and setup any real-time updates
  }

  resumeSimulation(): void {
    console.log('Resuming simulation');
  }

  toggleViewMode(mode: 'grid' | 'list'): void {
    this.viewMode = mode;
  }

  getStatusColor(status: string): string {
    switch (status) {
      case 'Processing':
        return 'info';
      case 'Queued':
        return 'warning';
      case 'Completed':
        return 'success';
      case 'Failed':
        return 'danger';
      default:
        return 'secondary';
    }
  }

  getTotalRecords(file: any): number {
    if(file.ProcessingItems?.length) {
      return file.ProcessingItems.reduce((total: number, item: any) => total + ((Number(item.Processed) + Number(item.Failed)) || 0), 0);
    }
    return 0
  }

  getFailedItems(file: any): number {
    if(file.ProcessingItems?.length) {
      return file.ProcessingItems.filter((item: any) => item.Status === 'Failed').reduce((total: number, item: any) => total + (Number(item.Failed) || 0), 0);
    }
    return 0
  }
  getCompletedItems(file: any): number {
    if(file.ProcessingItems?.length) {
      return file.ProcessingItems.filter((item: any) => item.Status === 'Completed').reduce((total: number, item: any) => total + (Number(item.Processed) || 0), 0);
    }
    return 0;
  }
  getQueuedItems(file: any): number {
    if(file.ProcessingItems?.length) {
      return file.ProcessingItems.filter((item: any) => item.Status === 'Queued').reduce((total: number, item: any) => total + (Number(item.Queued) || 0), 0);
    }
    return 0;
  }

  getProgressPercentage(file: any): number {
    if (file.ProcessingItems?.length) {
      const total = this.getTotalRecords(file);
      const completed = this.getCompletedItems(file);
      return total > 0 ? Math.round((completed / total) * 100) : 0;
    }
    return 0;
  }
  
}
